import {
  getChatPath,
  getChatSendPath,
  getMessagesList,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { chatActions } from "../reducers/chat";
import { t } from "i18next";
import { toast } from "react-toastify";

export const fetchChatItem = () => {
  return (dispatch) => {
    return apiService
      .get(getChatPath())
      .then((response) => {
        dispatch(chatActions.fetchChatItem(response.data));
        dispatch(fetchChatMessageList(response?.data?.id));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchChatSend = (formData, id) => {
  return (dispatch) => {
    return apiService
      .postMultipart(getChatSendPath(), formData)
      .then((response) => {
        dispatch(fetchChatMessageList(id));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchChatMessageList = (id, page = 0, size = 1000) => {
  return (dispatch) => {
    return apiService
      .get(getMessagesList(id, page, size))
      .then((response) => {
        dispatch(chatActions.fetchChatMessagesList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("security.error.refresh"), { theme: "colored" });
  }
  toast.error(errorMessage, { theme: "colored" });
};
